import { render, staticRenderFns } from "./ExamInstructions.vue?vue&type=template&id=ab5e4fa8&scoped=true&"
import script from "./ExamInstructions.vue?vue&type=script&lang=js&"
export * from "./ExamInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ExamInstructions.vue?vue&type=style&index=0&id=ab5e4fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e4fa8",
  null
  
)

export default component.exports